import { BookOpen } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { PhysicalInterest } from "../components/PhysicalInterest";

export const Ringbuch = () => (
  <section className="py-24 sm:py-32" id="ringbuch" style={{ background: "var(--paper-deep)" }} data-testid="ringbuch-section">
    <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <span
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] font-semibold px-4 py-2 rounded-full mb-6"
          style={{ background: "#FCF7EB", color: "#A97516", border: "1px solid rgba(229,169,60,0.4)" }}
          data-testid="ringbuch-badge"
        >
          <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: "#E5A93C" }} />
          Wir prüfen das Interesse
        </span>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-7">
          VisualMA bald auch zum <em style={{ color: "var(--terra)" }}>Anfassen?</em>
        </h2>
        <div className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed space-y-4 mb-8">
          <p>
            Wir prüfen aktuell, ob „Kleine Welt, große Farben" zusätzlich als hochwertiges
            physisches Kinderbuch erscheinen soll.
          </p>
          <p className="font-display text-lg sm:text-xl text-[color:var(--ink)]">
            Hättest du Interesse an einer gedruckten Version?
          </p>
        </div>
        <PhysicalInterest source="homepage" />
      </Reveal>

      <Reveal delay={0.15} className="relative hidden lg:block">
        <div className="blob floaty-slow" style={{ background: "rgba(229,169,60,0.16)", width: "90%", height: "85%", top: "6%", left: "8%" }} />
        <div className="relative card-soft aspect-[4/3] flex flex-col items-center justify-center gap-5 rotate-[2deg]">
          <div className="flex gap-2">
            {[..."ooooo"].map((_, i) => (
              <span key={i} className="w-3.5 h-3.5 rounded-full border-[3px]" style={{ borderColor: "var(--terra)" }} />
            ))}
          </div>
          <BookOpen size={54} strokeWidth={1.2} style={{ color: "var(--terra)" }} />
          <p className="font-display italic text-xl text-[color:var(--ink-muted)]">Eine mögliche physische Ausgabe</p>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[color:var(--ink-muted)]">Idee · Noch nicht in Produktion</p>
        </div>
      </Reveal>
    </div>
  </section>
);
